import React from 'react';

// بانر علوي بسيط لصفحات المحتوى الداخلية (مركز المساعدة، الوظائف، السياسات، إلخ)
const PageBanner = ({ eyebrow, title, subtitle }) => {
  return (
    <div className="bg-[#F2B705]" dir="rtl">
      <div className="container mx-auto px-4 py-14 text-center">
        {eyebrow && (
          <span className="inline-block px-4 py-1 rounded-full bg-[#1B1B1F]/10 text-[#1B1B1F] text-sm font-bold mb-4">
            {eyebrow}
          </span>
        )}

        <h1
          className="text-3xl md:text-5xl font-extrabold text-[#1B1B1F] mb-3"
          style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
        >
          {title}
        </h1>

        {subtitle && (
          <p className="text-[#1B1B1F]/70 text-lg max-w-2xl mx-auto leading-8">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default PageBanner;
